import {makeThemeProps} from "src/themes/utils/utils";

export default (theme, site, options = {}) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getSortFiltersProps(theme, options).sort;
};
